import template from './cardRequestDays.html';
import controller from './cardRequestDays.controller';
import './cardRequestDays.scss';

let cardRequestDaysComponent = {
  restrict: 'E',
  bindings: {
    cardData: '<',
    requested: '<',
    approved: '<',
    sendRequest: '&',
    sendEditNotification: '&',
    focused: '&',
    isMobileApp :'<',
  },
  template,
  controller,
};

export default cardRequestDaysComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestDays/cardRequestDays.component.js